import { render } from "./MPFDefault.vue?vue&type=template&id=459b4cae&ts=true"
import script from "./MPFDefault.vue?vue&type=script&lang=ts"
export * from "./MPFDefault.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__